import { render, staticRenderFns } from "./PRO_ByProviderTrendingPrintable.vue?vue&type=template&id=70593a16&scoped=true&"
import script from "./PRO_ByProviderTrendingPrintable.vue?vue&type=script&lang=js&"
export * from "./PRO_ByProviderTrendingPrintable.vue?vue&type=script&lang=js&"
import style0 from "./PRO_ByProviderTrendingPrintable.vue?vue&type=style&index=0&id=70593a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70593a16",
  null
  
)

export default component.exports